module.exports = __webpack_public_path__ + "53ac41cd7a3d655db29c1ccfb4f311fd.fbx";